export function hasNestedLinks(link) {
  return link.nestedLinks && link.nestedLinks.length > 0;
}
export function isLinkSelected(link, selectedLink) {
  return link.label === selectedLink || link.id === selectedLink;
}